import { Modal } from '@seiue/ui'

import { Notification } from 'packages/sdks-next/growp'

import {
  EditHotNewsModal,
  HotNewsModalProps,
} from './components/EditHotNewsModal'

/**
 * 打开编辑通知弹窗
 *
 * @param props - 参数
 * @param props.notification - 通知
 * @param props.reload - 刷新列表
 * @param props.justEditContent - 是否只编辑内容
 */
export const openEditHotNewsModal = (
  props: Omit<HotNewsModalProps, 'onClose'>
) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    children: (
      <EditHotNewsModal
        onClose={() => hide()}
        {...props}
      />
    ),
  })
}
